import React, { FC } from 'react';
import Typography from '@mui/material/Typography';
import { BaseBadge, BaseTooltip } from '@mgm/common/components/base';
import { TMultiLocations } from './type';

const MultiLocations: FC<TMultiLocations> = ({ locations }) => {
  if (Array.isArray(locations) && locations.length > 1) {
    return (
      <BaseTooltip tooltipText={(
        <>
          {locations.map((location) => (
            <Typography variant="body2" key={location.id}>
              {location.name}
            </Typography>
          ))}
        </>
      )}
      >
        <BaseBadge color="primary" badgeContent={locations.length}>
          <Typography variant="caption">
            {locations[0]?.name || '/'}
          </Typography>
        </BaseBadge>
      </BaseTooltip>
    );
  }

  return (
    Array.isArray(locations)
      ? (
        <Typography variant="caption">
          {locations[0]?.name || '/'}
        </Typography>
      )
      : (
        <Typography variant="caption">
          {locations}
        </Typography>
      )
  );
};

// Wrap with React.memo
export const MemoizedMultiLocations = React.memo(MultiLocations);
